export const loadInfoPanel = (artifactId, data, metadata, deps) => {
    const { artifactActions, addStatus } = deps;
    try {
        const htmlContent = new TextDecoder().decode(data);
        const infoPanelData = {
            id: artifactId,
            title: metadata.getName(),
            content: htmlContent,
            metadata: metadata
        };
        artifactActions.updateLoaded(artifactId, {
            type: 'info',
            cesiumObject: infoPanelData,
            metadata: metadata
        });
        artifactActions.resetRetryCount(artifactId);
        // Open the panel as part of loading. Info panels are only ever loaded by an
        // explicit user action (the info button), so loading and showing are a
        // single step — this removes the old two-click (load, then show) behaviour.
        const alreadyOpen = deps.artifactState.activeOverlays.info.some(panel => panel.id === artifactId);
        if (!alreadyOpen) {
            artifactActions.addInfoPanel(infoPanelData);
        }
        artifactActions.updateVisibility(artifactId, true);
        artifactActions.setLoading(artifactId, false);
    }
    catch (error) {
        artifactActions.setLoading(artifactId, false);
        addStatus(`Error creating info panel: ${error}`);
    }
};
